var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"headerContainer",staticClass:"header-container"},[_c('div',{staticClass:"title",on:{"click":_vm.copyLocalStorageToClipboard}},[_vm._v("Sonny Tracker")]),_c('TrackerSearch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }